<template>
  <div class="container">
    <!-- 三按钮确认对话框 -->
    <el-dialog
      v-model="dialogVisible"
      title="下推订单确认"
      width="30%"
      :before-close="handleDialogClose"
    >
      <span>确定要下推该订单到金蝶系统吗？</span>
      <div style="margin-top: 15px;">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="销售组织">
            <el-select
              v-model="formInline.SaleOrgId"
              placeholder="请选择销售组织"
              style="width: 120px"
            >
              <el-option label="301" value="301"></el-option>
              <el-option label="303" value="303"></el-option>
              <el-option label="304" value="304"></el-option>
              <el-option label="306" value="306"></el-option>
              <el-option label="310" value="310"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存组织">
            <el-select
              v-model="formInline.StockOrgId"
              placeholder="请选择库存组织"
              style="width: 120px"
            >
              <el-option label="301" value="301"></el-option>
              <el-option label="303" value="303"></el-option>
              <el-option label="304" value="304"></el-option>
              <el-option label="306" value="306"></el-option>
              <el-option label="310" value="310"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应组织">
            <el-select
              v-model="formInline.SupplyOrgId"
              placeholder="请选择供应组织"
              style="width: 120px"
            >
              <el-option label="201" value="201"></el-option>
              <el-option label="301" value="301"></el-option>
              <el-option label="303" value="303"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      
      <div style="margin-top: 15px;">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="客户名称">
            <el-input
              v-model="customerName"
              placeholder="客户名称"
              style="width: 200px"
            />
          </el-form-item>
        </el-form>
      </div>
            <div style="margin-top: 15px;">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="金蝶订单编号">
            <el-input
              v-model="salesRecordNumber"
              placeholder="金蝶订单编号"
              style="width: 200px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 15px;">
        <div style="font-weight: bold; margin-bottom: 10px;">请选择分摊下推主 SKU</div>
        <div class="sku-list">
          <div 
            v-for="(sku, index) in currentRowOthers" 
            :key="index" 
            class="sku-item"
            @click="selectSku(index)"
          >
            <span class="sku-text">{{ sku }}</span>
            <div class="sku-checkbox">
              <el-checkbox 
                :model-value="selectedSkuIndex === index" 
                @click.stop="selectSku(index)"
              />
            </div>
          </div>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleDialogCancel">取消</el-button>
          <el-button type="primary" @click="handleApportionPush" :disabled="selectedSkuIndex === null">分摊下推</el-button>
          <el-button @click="handleNonApportionPush">不分摊下推</el-button>
        </span>
      </template>
    </el-dialog>
    
    <div id="header">
      <div class="flex flex-row-left margin-top-20">
        <div class="flex-item-center">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" @submit.prevent="onSubmit">
            <el-form-item label="订单号相关">
              <el-input
                style="width: 200px"
                v-model="formInline.saleOrder"
                placeholder="马帮订单号,交易号"
                clearable
                @keyup.enter="onSubmit"
              />
            </el-form-item>
            <el-form-item label="是否重发">
              <el-select
                style="width: 120px"
                v-model="formInline.isResend"
                placeholder="请选择"
              >
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
          :max-height="dynamicHeight"
          :data="tableData"
          :preserve-expanded-content="true"
          :stripe="true"
          :border="true"
          :highlight-current-row="true"
          size="default"
        >
          <el-table-column
            label="交易号"
            min-width="160"
            prop="salesRecordNumber"
          ></el-table-column>
          <el-table-column
            label="订单编号"
            min-width="160"
            prop="PlatformOrderId"
          ></el-table-column>
          <el-table-column
            label="店铺"
            min-width="130"
            prop="shopName"
          ></el-table-column>
          <el-table-column
            label="客户"
            min-width="120"
            prop="BuyerUserId"
          ></el-table-column>
          <el-table-column
            label="币别"
            min-width="80"
            prop="currencyId"
          ></el-table-column>
          <el-table-column
            label="SKU及数量"
            min-width="180"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.sku.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="单价金额"
              min-width="180"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.prices.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="出库仓"
            min-width="220"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.stockWarehouseNames.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="金蝶订单号"
            min-width="120"
            prop="kingdee_xsddh"
          ></el-table-column>
          <el-table-column
            label="金蝶出库单号"
            min-width="120"
            prop="kingdee_xsckdh"
          ></el-table-column>
          <el-table-column
            label="是否重发"
            min-width="100"
            prop="isResend"
          >
            <template #default="scope">
              <span v-if="scope.row.isResend === 0">否</span>
              <span v-else-if="scope.row.isResend === 1">重发单</span>
              <span v-else>{{ scope.row.isResend }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作状态"
            min-width="120"
            prop="status"
          >
            <template #default="scope">
              <span v-if="scope.row.status === 0">待拉取马帮信息</span>
              <span v-else-if="scope.row.status === 1">待推送订单</span>
              <span v-else-if="scope.row.status === 2">待推送出库单</span>
              <span v-else-if="scope.row.status === 3">已完结</span>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单备注"
            min-width="150"
            prop="remark"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="马帮创建日期"
            min-width="150"
            prop="CreateTime"
          ></el-table-column>
          <el-table-column
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template #default="scope">
              <div class="operation-buttons">
                <el-button
                  type="warning"
                  size="small"
                  :loading="loadingRow === scope.row"
                  @click="handlePullInfo(scope.row)"
                  style="margin-bottom: 5px;"
                >
                  拉取马帮信息
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="handlePushOrder(scope.row)"
                  style="margin-bottom: 5px;"
                >
                  下推订单
                </el-button>
                <el-button
                  type="success"
                  size="small"
                  @click="handlePushStock(scope.row)"
                >
                  下推出库单
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="pageTotal"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="total, sizes, prev, pager, next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElPagination,
  ElTable,
  ElTableColumn,
  ElMessageBox,
  ElMessage,
  ElDialog,
  ElSelect,
  ElOption,
  ElCheckbox
} from "element-plus";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import { get_mabang_offline_order, get_mabang_order_detail, push_kingdee_order, push_saleOrder } from "@/utils/api";

export default {
  name: "mabangToKindee",
  components: {
    ElForm,
    ElFormItem,
    ElButton,
    ElInput,
    ElTable,
    ElTableColumn,
    ElPagination,
    ElDialog,
    ElSelect,
    ElOption,
    ElCheckbox
  },
  mixins: [DynamicHeightMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      pageTotal: 0,
      formInline: {
        saleOrder: "",
        isResend: 0,
        SaleOrgId: "304",
        StockOrgId: "303",
        SupplyOrgId: "201"
      },
      tableData: [],
      loadingRow: null, // 用于跟踪正在加载的行
      dialogVisible: false, // 控制对话框显示
      currentRow: null, // 当前操作的行数据
      selectedSkuIndex: null, // 当前选中的 SKU 索引
      salesRecordNumber: "", // 金蝶订单编号
      currentRowOthers: [], // 当前行的 others 字段数据
      customerName: "" // 客户名称
    };
  },
  mounted() {
    this.getMabangOfflineOrderData();
  },
  methods: {
    onSubmit(event) {
      if (event) {
        event.preventDefault();
      }
      this.currentPage = 1;
      this.getMabangOfflineOrderData();
    },
    getMabangOfflineOrderData() {
      const params = {
        PageNumber: this.currentPage,
        PageSize: this.pageSize,
        ...this.formInline
      };
      
      // 处理是否重发参数
      if (this.formInline.isResend !== null && this.formInline.isResend !== undefined) {
        params.isResend = this.formInline.isResend;
      }
      
      get_mabang_offline_order(params)
        .then(res => {
          console.log(res);
          this.tableData = res.Data || [];
          this.pageTotal = res.Total || 0;
        })
        .catch(err => {
          console.error(err);
          this.tableData = [];
          this.pageTotal = 0;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMabangOfflineOrderData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMabangOfflineOrderData();
    },
    // 拉取马帮信息操作
    handlePullInfo(row) {
      ElMessageBox.confirm(
        '确定要拉取该订单的马帮信息吗？',
        '拉取马帮信息确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 设置当前行的loading状态
        this.loadingRow = row;
        
        // 调用实际的拉取马帮信息接口
        const params = {
          saleOrder: row.salesRecordNumber,
          shopId: row.shopId
        };
        
        get_mabang_order_detail(params)
          .then(res => {
            if (res.Code === 0) {
              // 操作成功
              ElMessage.success('马帮信息拉取成功');
              // 保持当前查询条件，重新查询数据
              this.getMabangOfflineOrderData();
            } else {
              ElMessage.error(res.Msg || '马帮信息拉取失败');
              // 清除loading状态
              this.loadingRow = null;
            }
          })
          .catch(err => {
            console.error(err);
            ElMessage.error('马帮信息拉取失败');
            // 清除loading状态
            this.loadingRow = null;
          });
      }).catch(() => {
        // 用户取消操作
        ElMessage.info('已取消拉取马帮信息');
      });
    },
    // 下推订单操作
    handlePushOrder(row) {
      // 保存当前行数据并显示对话框
      this.currentRow = row;
      // 默认带出金蝶订单编号，重发单额外拼接 _1
      this.salesRecordNumber = '070.' + row.salesRecordNumber + (row.isResend === 1 ? '_1' : '');
      // 初始化 others 数据
      this.currentRowOthers = row.others || [];
      // 重置选中的 SKU 索引
      this.selectedSkuIndex = null;
      // 处理 customer_name：截取 dba 前面的字符，去掉末尾小数点
      let customer_name = row.BuyerUserId || '';
      // 截取 dba 前面的字符（如果没有 dba 则保持原样）
      const parts = customer_name.split("dba");
      customer_name = parts[0];
      // 去除首尾空格
      customer_name = customer_name.trim();
      // 去掉末尾的小数点（如果有的话）
      // customer_name = customer_name.replace(/\.+$/, '');
      this.customerName = customer_name;
      // 根据币别设置销售组织和库存组织默认值
      if (row.currencyId === 'EUR') {
        this.formInline.SaleOrgId = '310';
        this.formInline.StockOrgId = '301';
      } else if (row.currencyId === 'GBP') {
        this.formInline.SaleOrgId = '306';
        this.formInline.StockOrgId = '301';
      } else {
        this.formInline.SaleOrgId = '304';
        this.formInline.StockOrgId = '303';
      }
      this.formInline.SupplyOrgId = '201';
      this.dialogVisible = true;
    },
    
    // 选择 SKU
    selectSku(index) {
      if (this.selectedSkuIndex === index) {
        // 如果点击的是已选中的，则取消选择
        this.selectedSkuIndex = null;
      } else {
        // 否则选择当前点击的
        this.selectedSkuIndex = index;
      }
    },
    
    // 对话框关闭处理
    handleDialogClose(done) {
      // 直接关闭对话框，无需确认
      done();
    },
    
    // 对话框取消按钮处理
    handleDialogCancel() {
      this.dialogVisible = false;
      ElMessage.info('已取消下推订单');
    },
    
    // 分摊下推处理
    handleApportionPush() {
      this.dialogVisible = false;
      this.executePushOrder(this.currentRow, true);
    },
    
    // 不分摊下推处理
    handleNonApportionPush() {
      this.dialogVisible = false;
      this.executePushOrder(this.currentRow, false);
    },
    
    // 执行下推订单的实际操作
    executePushOrder(row, isApportion) {
      // 调用实际的下推订单接口
      const params = {
        saleOrder: row.salesRecordNumber,
        kindeeOrder: this.salesRecordNumber,
        apportion: isApportion,
        isResend: row.isResend,
        SaleOrgId: this.formInline.SaleOrgId,
        StockOrgId: this.formInline.StockOrgId,
        SupplyOrgId: this.formInline.SupplyOrgId,
        customerName: this.customerName
      };
      
      // 如果是分摊下推，添加选中的 SKU 信息
      if (isApportion && this.selectedSkuIndex !== null) {
        params.MainSku = this.currentRowOthers[this.selectedSkuIndex];
      }
      
      push_kingdee_order(params)
        .then(res => {
          if (res.Code === 0) {
            // 操作成功
            ElMessage.success('订单下推成功');
            // 保持当前查询条件，重新查询数据
            this.getMabangOfflineOrderData();
          } else {
            ElMessage.error(res.Msg || '订单下推失败');
          }
        })
        .catch(err => {
          console.error(err);
          ElMessage.error('订单下推失败');
        });
    },
    // 下推出库单操作
    handlePushStock(row) {
      ElMessageBox.confirm(
        '确定要下推出库单到金蝶系统吗？',
        '下推出库单确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 调用实际的下推出库单接口
        const params = {
          saleOrder: row.kingdee_xsddh
        };
        
        push_saleOrder(params)
          .then(res => {
            if (res.Code === 0) {
              // 操作成功
              ElMessage.success('出库单下推成功');
              // 保持当前查询条件，重新查询数据
              this.getMabangOfflineOrderData();
            } else {
              ElMessage.error(res.Msg || '出库单下推失败');
            }
          })
          .catch(err => {
            console.error(err);
            ElMessage.error('出库单下推失败');
          });
      }).catch(() => {
        // 用户取消操作
        ElMessage.info('已取消下推出库单');
      });
    }
  }
};
</script>

<style scoped>
.container {
  width: 92%;
  margin: 0 auto;
}

::v-deep .container .el-form-item {
  margin-bottom: 0 !important;
}



.operation-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
}

.multi-line-ellipsis {
  word-break: break-word;
}

.line-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sku-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
}

.sku-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: relative;
}

.sku-item:hover {
  background-color: #f5f7fa;
}

.sku-text {
  flex: 1;
  text-align: left;
  word-break: break-all;
}

.sku-checkbox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>